import React from 'react';
import {Avatar} from '@tempo/core';
import {useUserData} from '@app/hooks/controllers/useUserData';
import {useRouter} from 'next/router';

const WrappedAvatar: React.FC = () => {
	const {user} = useUserData();
	const router = useRouter();

	const isAuthPage =
		router.pathname.includes('/signup') || router.pathname.includes('/login');

	if (!user || isAuthPage) return null;

	return (
		<Avatar
			name={user.blogName}
			size="size.m"
			color="text.neutral.primary.default"
			src={user.getPictureUrl(150, 150, '#FFFFFF', 'user')}
		/>
	);
};

export default WrappedAvatar;
